import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Spinner from "common/components/Spinner"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Trans, useTranslation } from "react-i18next"

export interface ModalOcrUnverifiedProviderProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  isLoading: boolean
}

export const ModalConfirmDelete = ({
  isOpen = false,
  onCancel,
  onConfirm,
  isLoading,
}: ModalOcrUnverifiedProviderProps) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-112 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='Continuar'
          className='tw-flex tw-flex-row tw-px-4 tw-pb-1 tw-gap-3'
        >
          <ButtonPrimeReact
            label={`${t("tickets.delete.cancelButton")}`}
            className='tw-w-full tw-h-12 !tw-bg-inherit !tw-text-primary !tw-border-none'
            onClick={onCancel}
            disabled={isLoading}
          />
          <ButtonPrimeReact
            label={`${t("categoryManagement.modal.continueButton")}`}
            className='tw-w-full tw-h-12 !tw-bg-primary tw-text-simple-10'
            onClick={onConfirm}
            disabled={isLoading}
          />
        </div>
      }
    >
      <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-4'>
        {isLoading ? (
          <Spinner className='!tw-mt-0' />
        ) : (
          <div className='tw-rounded-full tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-border tw-border-simple-90 tw-border-opacity-5 tw-bg-white tw-mx-auto'>
            <FontAwesomeIcon
              icon={["fal", "trash-alt"]}
              className='tw-w-8 tw-h-8 tw-text-danger'
            />
          </div>
        )}
      </div>
      <div className='tw-text-xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
        {t("categoryManagement.modal.deleteHeader")}
      </div>
      <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-px-4'>
        <p className='tw-mb-3 tw-text-center'>
          <Trans
            i18nKey='categoryManagement.modal.deleteMessage'
            components={[
              <span
                className='tw-font-medium tw-contents'
                key='0'
              />,
            ]}
          />
        </p>
      </div>
    </PrimeReactModal>
  )
}
